function normalizeMethodKey(value) {
  return String(value ?? "").trim().toLocaleLowerCase();
}

function listDistinctExpenseTextOptions(rows = [], field) {
  const optionLabelsByKey = new Map();

  for (const row of rows) {
    const label = String(row?.[field] ?? "").trim();

    if (!label) {
      continue;
    }

    const normalizedKey = normalizeMethodKey(label);

    if (!normalizedKey || optionLabelsByKey.has(normalizedKey)) {
      continue;
    }

    optionLabelsByKey.set(normalizedKey, label);
  }

  return Array.from(optionLabelsByKey.values()).sort((left, right) => (
    left.localeCompare(right, undefined, { sensitivity: "base" })
  ));
}

export function listExpenseMethodOptions(rows = []) {
  return listDistinctExpenseTextOptions(rows, "method");
}

export function listExpenseSupplierOptions(rows = []) {
  return listDistinctExpenseTextOptions(rows, "supplier");
}

export function listExpenseServiceOptions(rows = []) {
  return listDistinctExpenseTextOptions(rows, "service");
}
